export default __webpack_public_path__ + "static/media/pricetracq-pin.14c7c7d0.svg";